export const enum ClmPortalOutgoingPostMessageTypes {
  RE_FETCH_PARTNER = 'refetchPartner',
  CHANGE_TAB_SAVE_CHECK = 'changeTabSaveCheck',
  SET_PARTNER_PROFILE = 'setPartnerProfile',
  INJECT_GRAVITY = 'injectGravity',
  RE_FETCH_CORE_DATA = 'refetchCoreData',
  TASK_VIEWER_SEND_URL_PARAMS = 'taskViewerSendUrlParams',
  WORKFLOW_DASHBOARD_SEND_URL_PARAMS = 'workflowDashboardSendUrlParams',
}

export const enum ClmPortalIncomingPostMessageTypes {
  CHANGE_URL = 'changeUrl',
  OPEN_IN_NEW_TAB = 'openInNewTab',
  SET_ACCOUNT_DETAILS = 'setAccountDetails',
  REDIRECT_DOC_TAB_V2 = 'redirectDocumentTab_V2',
  REDIRECT_MSD = 'redirectMSD',
  REDIRECT_TO_PARTNER = 'redirectToPartner',
  REDIRECT_TO_TASK = 'redirectToTask',
  SEE_ACCOUNT_LIST = 'seeAccountList',
  REDIRECT_TO_RISK_CONSIDERATIONS = 'redirectToRiskConsiderations',
  NEW_TAB_BR_CORE_DATA = 'newTabBrCoreData',
  OPEN_NEW_BR_TAB = 'openNewBrTab',
  OPEN_WORKFLOW = 'openWorkflow',
  NEW_TAB_OPEN_DOCUMENT = 'newTabOpenDocument',
  SAVED_BR = 'savedBr',
  CHANGE_TAB_PARTNER_PROFILE = 'partner-profile',
  CHANGE_TAB = 'changeTab',
  CHANGE_TAB_REPORTING = 'reporting',
  CHANGE_TAB_CORE_DATA = 'core-data',
  CHANGE_TAB_PRODUCTS_AND_SERVICES = 'products-and-services',
  CHANGE_TAB_INVESTMENT_PROFILE = 'investment-profile',
  CHANGE_TAB_TO_ACTIVITY_TIMELINE = 'activity-timeline',
  CHANGE_TAB_BR_SERVICING = 'br-servicing-roles',
  RE_FETCH_PARTNER = 'refetchPartner',
  UPDATE_INTENDED_ROLE = 'updateIntendedRole',
  SHOULD_DISABLE_TABS = 'shouldDisableTabs',
  REDIRECT_CORE_DATA_TAB = 'redirectCoreDataTab',
  SAVED_PARTNER = 'savedPartner',
  CLOSE_MODAL = 'closeModal',
  CLOSE_CONTACT_NOTE_MODAL = 'closeContactNoteModal',
  SEND_CONTACT_NOTE_DATA = 'sendContactNoteData',
  REDIRECT_DOCUMENT_TAB_SHOW_CONTENT = 'redirectDocumentTabShowContent',
  REDIRECT_AGREEMENT_FORWARDING = 'redirectAgreementForwarding',
  UPDATE_NOTIFICATIONS = 'updateNotifications',
  COPY_TO_CLIPBOARD_FROM_TASK_VIEWER = 'copyToClipboardFromTaskViewer',
  RE_FETCH_PARTNER_LOCK_STATUS = 'refetchPartnerLockStatus',
  SEE_PARTNER_LIST = 'seePartnerList',
  NEW_TAB_BR_PARTNER_RELATIONS = 'newTabBrPartnerRelations',
  NEW_TAB_CREATE_CLIPP_PRICING = 'newTabCreateClippPricing',
  OPEN_PARTNER_TAB = 'openPartnerTab',
  OPEN_DRAWER = 'openDrawer',
  CLOSE_DRAWER = 'closeDrawer',
  SEE_CONTACT_NOTE = 'seeContactNote',
  SEE_DOCUMENTS = 'seeDocuments',
  NO_INITIATOR = 'NO_INITIATOR',
  REDIRECT_TO_RELATED_PARTNER = 'redirectToRelatedPartner',
  CHANGE_TAB_NO_CONFIRMATION = 'changeTabNoConfirmation',
  OPEN_DISTRIBUTION_PCD2 = 'OPEN_DISTRIBUTION_PCD2',
  REDIRECT_TO_BR = 'redirectToBr',
  SHOW_REQUEST_COVERAGE_DOMICILE_EXCEPTION = 'showRequestCoverageDomicileException',
  REDIRECT_TO_TOOLS = 'redirectToTools',
  RELOAD_PAGE = 'reloadPage',
  UPDATE_SANCTIONS_INFO = 'updateSanctionsInfo',
  TASK_VIEWER_URL_PARAMS_CHANGED = 'taskViewerUrlParamsChanged',
  TASK_VIEWER_READY = 'taskViewerReady',
  VIEW_TASK = 'viewTask',
  WORK_ON_TASK = 'workOnTask',
  WORKFLOW_DASHBOARD_URL_PARAMS_CHANGED = 'workflowDashboardUrlParamsChanged',
  WORKFLOW_DASHBOARD_READY = 'workflowDashboardReady',
}
